import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// PERF FIX: Render React FIRST, then lazy-init Sentry after first paint
// This removes ~100KB from critical path and speeds up TTI
createRoot(document.getElementById("root")!).render(<App />);

// Lazy initialize Sentry in production only - after React has rendered
if (import.meta.env.PROD) {
  // Use requestIdleCallback to defer Sentry init until browser is idle
  const initSentry = () => {
    import("@sentry/react").then(async (Sentry) => {
      const { APP_VERSION, BUILD_DATE } = await import("./lib/version");
      const { beforeSend } = await import("./lib/sentry");
      
      const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined;
      if (!SENTRY_DSN) {
        console.warn('[Sentry] Skipped init (missing VITE_SENTRY_DSN)');
        return;
      }
      
      Sentry.init({
        dsn: SENTRY_DSN,
        environment: import.meta.env.MODE,
        release: `germanpath@${APP_VERSION}`,
        sendDefaultPii: true,
        sampleRate: 1.0,
        tracesSampleRate: 0.3,
        tracePropagationTargets: [
          "localhost",
          /^https:\/\/germanpath\.lovable\.app/,
          /^https:\/\/bxakjeixathaywyewymq\.supabase\.co/,
        ],
        replaysOnErrorSampleRate: 1.0,
        integrations: [
          Sentry.browserTracingIntegration({ enableInp: true }),
          Sentry.replayIntegration({
            maskAllText: false,
            maskAllInputs: true,
            blockAllMedia: false,
          }),
          Sentry.feedbackIntegration({
            colorScheme: 'system',
            showBranding: false,
            autoInject: false,
          }),
        ],
        beforeSend,
        initialScope: {
          tags: {
            'app.version': APP_VERSION,
            'app.buildDate': BUILD_DATE,
          },
        },
        ignoreErrors: [
          'top.GLOBALS',
          'originalCreateNotification',
          'canvas.contentDocument',
          'MyApp_RemoveAllHighlights',
          'http://tt.teleportstudios.com',
          'atomicFindClose',
          /extensions\//i,
          /^chrome:\/\//i,
          'ResizeObserver loop',
          'Non-Error promise rejection',
        ],
      });
      
      console.log(`[Sentry] Initialized (deferred) - version ${APP_VERSION}`);
    });
  };

  // Prefer requestIdleCallback, fallback to setTimeout
  if ('requestIdleCallback' in window) {
    requestIdleCallback(initSentry, { timeout: 3000 });
  } else {
    setTimeout(initSentry, 1000);
  }
}
